import React from "react";

const TransactionHistoryList = React.lazy(() => import("src/pages/transaction_history/TransactionHistoryList"));

const routes = [
    { path: "/dashboard/transaction-history", name: "Transaction History", element: TransactionHistoryList },
];

export default routes;
